<template>
  <div class="fee-config-detail-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('feeConfigDetail.feeItemInfo')" :subtitle="$t('feeConfigDetail.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="goBack">
          {{ $t('feeConfigDetail.page.back') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 费用项属性面板 -->
    <div class="ds-panel">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('feeConfigDetail.page.attrTitle') }}</span>
      </div>

      <div class="ds-info-grid">
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('feeConfigDetail.feeType') }}</span>
          <span class="ds-info-grid__value">{{ feeDetailInfo.feeTypeCdName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('feeConfigDetail.feeItem') }}</span>
          <span class="ds-info-grid__value">{{ feeDetailInfo.feeName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('feeConfigDetail.feeFlag') }}</span>
          <span class="ds-info-grid__value">{{ feeDetailInfo.feeFlagName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('feeConfigDetail.paymentCycle') }}</span>
          <span class="ds-info-grid__value">{{ feeDetailInfo.paymentCycle || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('feeConfigDetail.billType') }}</span>
          <span class="ds-info-grid__value">{{ feeDetailInfo.billTypeName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('feeConfigDetail.startTime') }}</span>
          <span class="ds-info-grid__value ds-num">{{ feeDetailInfo.startTime || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('feeConfigDetail.endTime') }}</span>
          <span class="ds-info-grid__value ds-num">{{ feeDetailInfo.endTime || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('feeConfigDetail.deductFrom') }}</span>
          <span class="ds-info-grid__value">
            <ds-status-tag :type="feeDetailInfo.deductFrom == 'Y' ? 'success' : 'muted'"
              :label="feeDetailInfo.deductFrom == 'Y' ? $t('common.yes') : $t('common.no')" />
          </span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('feeConfigDetail.payOnline') }}</span>
          <span class="ds-info-grid__value">
            <ds-status-tag :type="feeDetailInfo.payOnline == 'Y' ? 'success' : 'muted'"
              :label="feeDetailInfo.payOnline == 'Y' ? $t('common.yes') : $t('common.no')" />
          </span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('feeConfigDetail.scale') }}</span>
          <span class="ds-info-grid__value">{{ getScaleName(feeDetailInfo.scale) }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('feeConfigDetail.decimalPlace') }}</span>
          <span class="ds-info-grid__value ds-num">{{ feeDetailInfo.decimalPlace || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('feeConfigDetail.computingFormula') }}</span>
          <span class="ds-info-grid__value">{{ feeDetailInfo.computingFormulaName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('feeConfigDetail.squarePrice') }}</span>
          <span class="ds-info-grid__value ds-num ds-amount">{{ formatMoney(feeDetailInfo.squarePrice) }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('feeConfigDetail.additionalAmount') }}</span>
          <span class="ds-info-grid__value ds-num ds-amount">{{ formatMoney(feeDetailInfo.additionalAmount) }}</span>
        </div>
      </div>
    </div>

    <!-- (3) 明细 Tab 面板 -->
    <div class="ds-panel ds-panel--tabs">
      <el-tabs v-model="feeDetailInfo.currentTab" @tab-click="changeTab(feeDetailInfo.currentTab)">
        <el-tab-pane :label="$t('feeConfigDetail.modifyRecord')" name="feeConfigDetailHis">
          <fee-config-detail-his ref="feeConfigDetailHis"
            v-if="feeDetailInfo.currentTab === 'feeConfigDetailHis'"></fee-config-detail-his>
        </el-tab-pane>
        <el-tab-pane :label="$t('feeConfigDetail.createObject')" name="feeDetailFeeObj">
          <fee-detail-fee-obj ref="feeDetailFeeObj"
            v-if="feeDetailInfo.currentTab === 'feeDetailFeeObj'"></fee-detail-fee-obj>
        </el-tab-pane>
        <el-tab-pane :label="$t('feeConfigDetail.discount')" name="feeConfigDetailDiscount">
          <fee-config-detail-discount ref="feeConfigDetailDiscount"
            v-if="feeDetailInfo.currentTab === 'feeConfigDetailDiscount'"></fee-config-detail-discount>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getFeeConfigDetail } from '@/api/fee/feeConfigDetailApi'
import FeeConfigDetailHis from '@/components/fee/FeeConfigDetailHis'
import FeeDetailFeeObj from '@/components/fee/FeeDetailFeeObj'
import FeeConfigDetailDiscount from '@/components/fee/FeeConfigDetailDiscount'
import { formatMoney } from '@/utils/format'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'FeeConfigDetailList',
  components: {
    FeeConfigDetailHis,
    FeeDetailFeeObj,
    FeeConfigDetailDiscount,
    DsPageHeader,
    DsStatusTag
  },
  data() {
    return {
      feeDetailInfo: {
        configId: '',
        feeTypeCdName: '',
        feeName: '',
        feeFlagName: '',
        startTime: '',
        endTime: '',
        computingFormulaName: '',
        squarePrice: '',
        additionalAmount: '0.00',
        isDefault: '',
        billTypeName: '',
        paymentCycle: '',
        paymentCd: '',
        computingFormulaText: '',
        deductFrom: '',
        payOnline: 'Y',
        scale: '1',
        decimalPlace: '2',
        units: '元',
        currentTab: 'feeConfigDetailHis',
        needBack: false
      }
    }
  },
  created() {
    this.feeDetailInfo.configId = this.$route.query.configId
    if (this.feeDetailInfo.configId) {
      this.loadFeeDetailInfo()
    }
  },
  methods: {
    async loadFeeDetailInfo() {
      try {
        const params = {
          configId: this.feeDetailInfo.configId,
          communityId: this.getCommunityId(),
          page: 1,
          row: 1
        }
        const { feeConfigs } = await getFeeConfigDetail(params)
        Object.assign(this.feeDetailInfo, feeConfigs[0])
        this.changeTab(this.feeDetailInfo.currentTab)
      } catch (error) {
        console.error('Failed to load fee detail info:', error)
      }
    },
    changeTab(tab) {
      this.feeDetailInfo.currentTab = tab
      setTimeout(() => {
        this.$nextTick(() => {
          if (this.$refs[tab] && typeof this.$refs[tab].switchTab === 'function') {
            this.$refs[tab].switchTab({
              configId: this.feeDetailInfo.configId
            })
          }
        })
      }, 500)
    },
    getScaleName(scale) {
      if (scale == '1') return this.$t('feeConfigDetail.rounding')
      if (scale == '3') return this.$t('feeConfigDetail.upRound')
      if (scale == '4') return this.$t('feeConfigDetail.downRound')
      return '-'
    },
    formatMoney(value) {
      return formatMoney(value)
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.fee-config-detail-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-md);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--ds-spacing-sm) var(--ds-spacing-lg);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

/* Tab 面板 */
.ds-panel--tabs {
  padding: 0 var(--ds-spacing-lg) var(--ds-spacing-lg);
}

/* 信息栅格 */
.ds-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: var(--ds-spacing-md) var(--ds-spacing-lg);
  padding: var(--ds-spacing-lg);

  &__item {
    display: flex;
    align-items: baseline;
    gap: var(--ds-spacing-sm);
    min-width: 0;
  }

  &__label {
    flex-shrink: 0;
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-500);
  }

  &__value {
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-900);
    word-break: break-all;
  }
}

/* 金额强调 */
.ds-amount {
  font-weight: 600;
  color: var(--ds-gray-900);
}
</style>
